import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  Validators,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { UserService } from '../../services/user.service';
import { AuthService } from '../../services/auth.service';
import { DeviceService } from '../../services/device.service';
import * as L from 'leaflet';
import 'leaflet.markercluster';
import 'leaflet-control-geocoder';
import { User } from './../../models/user.model';
import { UserRoleEnum } from '../../enums/user-role-enum';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  ApexLegend,
  ApexPlotOptions,
  NgApexchartsModule,
  ApexDataLabels,
  ApexTooltip,
} from 'ng-apexcharts';
import { FormsModule } from '@angular/forms';
export type CustomChartOptions = ChartOptions & {
  tooltip?: ApexTooltip;
};
import {
  ChartComponent,
  ApexChart,
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexTitleSubtitle,
} from 'ng-apexcharts';
import { WebSocketService } from '../../services/web-socket.service';
import { environment } from '../../../environments/environment';
declare let require: any;
import {
  BsDatepickerModule,
  BsDatepickerConfig,
} from 'ngx-bootstrap/datepicker';
import {
  GoogleMap,
  MapMarkerClusterer,
  MapAdvancedMarker,
  MapMarker,
} from '@angular/google-maps';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
//declare var google: any;
export type ChartOptions = {
  chart: ApexChart;
  title: ApexTitleSubtitle;
  labels: string[];
  series: ApexNonAxisChartSeries;
  responsive: ApexResponsive[];
  plotOptions: ApexPlotOptions;
  colors: string[];
  legend: ApexLegend;
  dataLabels?: ApexDataLabels;
  noData: ApexNoData;
};

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    LeafletModule,
    ReactiveFormsModule,
    CommonModule,
    NgApexchartsModule,
    FormsModule,
    BsDatepickerModule,
    GoogleMap,
    MapMarkerClusterer,
    MapAdvancedMarker,
    MapMarker,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  map!: google.maps.Map;
  tillDateMinDate!: Date;
  dataMangementWidgetData: any = {};
  public chartLabels: string[] = [];
  public ChartSeries: number[] = [];
  public chartOptions!: ChartOptions;
  zoneForm!: FormGroup;
  datePickerConfig: Partial<BsDatepickerConfig>;
  today: Date = new Date();
  mapOptions: any;
  zoneList: any = [];
  domesticConsumption: any = 0;
  commercialConsumption: any = 0;
  nRWConsumption: any = 0;
  meterCount: any = 0;
  lastDevicecapturedTime: any;
  lastDevicecapturedTimeonInit: any;
  selectedZone: string = '';
  statusColorMap: any;
  private markers: L.Marker[] = [];
  chartColors = ['#FE9365', '#01A9AC', '#FE5D70'];
  loggedUser: User = new User();
  filterDateProcessed: string = '';
  filterDateUploaded: string = '';
  filterForm!: FormGroup;
  maxDate: Date = new Date();
  minDate!: Date;
  minDateInPick: any;
  maxDateInPick: any;
  zoneId: any;
  startDate: any;
  endDate: any;
  mapMarkers: google.maps.Marker[] = [];
  deviceMarkers: google.maps.Marker[] = [];
  infoWindow: google.maps.InfoWindow = new google.maps.InfoWindow();
  deviceZoomThreshold: number = 10;
  markerClusterGroup!: MarkerClusterer;
  markerDeviceGroup!: MarkerClusterer;
  googleMap!: google.maps.Map;
  markerPositions: google.maps.LatLngLiteral[] = [];
  allClusters: any;
  allDevices: any;
  markerClustererImagePath =
    'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';
  zoom = 2;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private readonly userService: UserService,
    private readonly authService: AuthService,
    private readonly deviceService: DeviceService,
    private readonly webSocketService: WebSocketService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {
    this.datePickerConfig = {
      dateInputFormat: 'DD-MM-YYYY',
      maxDate: this.today,
    };
  }
  ngAfterViewInit(): void {
    this.initMap();
  }

  private initMap(): void {
    const today = new Date();
    this.minDate = new Date(
      today.getFullYear(),
      today.getMonth() - 6,
      today.getDate()
    );

    const mapElement = document.getElementById('deviceMap') as HTMLElement;
    if (!mapElement) {
      console.error('Map element not found');
      return;
    }

    if (!this.map) {
      this.map = new google.maps.Map(mapElement, {
        center: { lat: 51.505, lng: -0.09 },
        zoom: 2,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      });

      const clusterOptions = {
        map: this.map,
        markers: [],
        maxZoom: 9,
        gridSize: 60,
      };

      this.markerClusterGroup = new MarkerClusterer(clusterOptions);
      this.markerDeviceGroup = new MarkerClusterer(clusterOptions);
      this.map.addListener('zoom_changed', () => {
        this.handleZoomChange();
      });

      console.log('Map and MarkerClusterer initialized.');
    }
  }

  onZoomChanged(event: any) {
    console.log('onZoomChanged');
  }
  ngOnInit(): void {
    this.loggedUser = this.authService.CurrentUserValue;
    if (!this.loggedUser.project_id) {
      this.router.navigateByUrl(environment.DefaultRetrunUrlForMasterAdmin);
    }
    this.getAllZone();
    this.getLatestCaptureDate();
    this.loadDeviceClusters();
    this.getDataManagementWidgetData();
    this.getDevicesStatusDetails();
    this.initMap();
    this.zoneForm = this.fb.group({
      zone: ['all'],
    });
    this.filterForm = this.fb.group({
      fromDate: [''],
      tillDate: [''],
    });
    this.filterForm
      .get('fromDate')
      ?.valueChanges.subscribe((fromDate: Date) => {
        this.tillDateMinDate = new Date(fromDate);
        const tillDate = this.filterForm.get('tillDate')?.value;
        if (tillDate && new Date(tillDate) < new Date(fromDate)) {
          this.filterForm.get('tillDate')?.reset();
        }
      });
    this.realTimeWidgetsUpdation();
    this.statusColorMap = {
      'Status OK': '#01A9AC',
      'Reporting Alarm': '#FE5D70',
      'Status Offline': '#FE9365',
    };

    this.filterForm.get('fromDate')?.valueChanges.subscribe((selectedDate) => {
      this.startDate = selectedDate;
    });
    this.filterForm.get('tillDate')?.valueChanges.subscribe((selectedDate) => {
      this.endDate = selectedDate;
    });
  }
  setChartColors(data: any) {
    this.chartColors = data.map((item: any) => {
      return this.statusColorMap[item.status] || this.statusColorMap.Offline;
    });
  }
  showChart() {
    this.chartOptions = {
      chart: {
        type: 'donut',
        width: '100%',
        height: '250px',
      },
      title: {
        text: 'Device Status',
        align: 'center',
      },
      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
      },
      labels: this.chartLabels,
      series: this.ChartSeries,
      colors: this.chartColors,
      responsive: [
        {
          //breakpoint: 480,
          options: {
            chart: {
              width: '100%',
            },
          },
        },
      ],
      plotOptions: {
        pie: {
          donut: {
            size: '50%',
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val: string, opts) {
          return opts.w.globals.series[opts.seriesIndex];
        },
      },
      noData: {
        text: 'No data available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
      },
    };
  }

  getAllZone() {
    this.deviceService.getAllZones().subscribe(
      (response: any) => {
        this.zoneList = response.data?.zones;
      },
      (err: any) => {
        console.log(err.error);
      }
    );
  }

  getLatestCaptureDate() {
    let body = {
      params: {
        zone_id: this.selectedZone,
      },
    };
    this.deviceService.getLatestCaptureDate(body).subscribe(
      (response: any) => {
        this.lastDevicecapturedTimeonInit = response.data;
        if (this.lastDevicecapturedTimeonInit) {
          const dateObject = new Date(this.lastDevicecapturedTimeonInit);
          const fromDate = new Date(dateObject);
          fromDate.setDate(dateObject.getDate() - 1);
          this.filterForm.patchValue({
            fromDate: fromDate,
            tillDate: dateObject,
          });
        }
        this.getWaterConsumptionWidgetDetails();
      },
      (err: any) => {
        console.log(err.error);
      }
    );
  }

  getWaterConsumptionWidgetDetails() {
    const startDate = this.filterForm.get('fromDate')?.value;
    const endDate = this.filterForm.get('tillDate')?.value;
    let body = {
      params: {
        zone_id: this.selectedZone,
        fromDate: startDate,
        endDate: endDate,
      },
    };
    if (startDate == '' || endDate == '') {
      delete body.params.fromDate;
      delete body.params.endDate;
    }
    this.spinner.show();
    this.deviceService.getWaterConsumptionWidgetDetails(body).subscribe(
      (response: any) => {
        this.domesticConsumption = response.data?.domesticUse
          ? response.data?.domesticUse
          : 0;
        this.commercialConsumption = response.data?.commercialUse
          ? response.data?.commercialUse
          : 0;
        this.nRWConsumption = response.data?.nRWUse ? response.data?.nRWUse : 0;
        this.meterCount = response.data?.totalMeterReading
          ? response.data?.totalMeterReading
          : 0;

        this.lastDevicecapturedTime = response.data?.latestDevicecapturedTime;
        this.spinner.hide();
      },
      (err: any) => {
        console.log(err.error);
        this.spinner.hide();
      }
    );
  }

  getDevicesStatusDetails() {
    let body = {
      params: {
        zone_id: this.selectedZone,
      },
    };
    this.deviceService.getDevicesStatusDetails(body).subscribe(
      (response: any) => {
        this.chartLabels = response.data.map((item: any) => item.status);
        this.ChartSeries = response.data.map((item: any) => +item.count);

        this.chartOptions = {
          ...this.chartOptions,
          labels: this.chartLabels,
          series: this.ChartSeries,
          colors: this.chartColors,
        };
        this.setChartColors(response.data);
        this.showChart();
      },
      (err: any) => {
        console.log(err.error);
      }
    );
  }
  onZoneChange() {
    this.loadDeviceClusters();
    this.getWaterConsumptionWidgetDetails();
    this.getDevicesStatusDetails();
    this.getDataManagementWidgetData();
  }
  private getDataManagementWidgetData(): void {
    let body = {
      params: {
        zone_id: this.selectedZone,
      },
    };
    this.deviceService
      .getDataManagementWidgetData(body)
      .subscribe((response: any) => {
        this.dataMangementWidgetData = response.data;
      });
  }

  private loadDeviceClusters(): void {
    const body = {
      params: {
        zone_id: this.selectedZone,
      },
    };

    this.deviceService.getAllDevicesMapdetails(body).subscribe(
      (response: any) => {
        this.allClusters = response.data.clusters || [];
        this.allDevices = response.data.devices || [];
        this.addClustersToMap(this.allClusters);
      },
      (error) => {
        console.error('Error loading device clusters:', error);
      }
    );
  }

  private addClustersToMap(clusters: any[]): void {
    this.clearMapMarkers();

    if (!clusters || clusters.length === 0) return;

    clusters.forEach((cluster) => {
      const latitude = parseFloat(cluster.latitude);
      const longitude = parseFloat(cluster.longitude);
      if (!isNaN(latitude) && !isNaN(longitude)) {
        const marker = this.createClusterMarker(latitude, longitude, cluster);
        this.mapMarkers.push(marker);
        this.markerClusterGroup?.addMarker(marker);
      }
    });
  }

  private addDeviceLocationsToMap(devices: any[]): void {
    // this.cleaDeviceMarkers();
    if (!devices || devices.length === 0) return;

    devices.forEach((device) => {
      const latitude = parseFloat(device?.latitude);
      const longitude = parseFloat(device?.longitude);
      if (!isNaN(latitude) && !isNaN(longitude)) {
        const marker = this.createDeviceMarker(latitude, longitude, device);
        this.deviceMarkers.push(marker);
        // this.markerDeviceGroup?.addMarker(marker);
      }
    });
    this.deviceMarkers.forEach((marker) => marker.setMap(this.map));
  }

  private handleZoomChange(): void {
    const currentZoom = this.map?.getZoom() || 0;

    if (currentZoom >= 9) {
      //this.clearMapMarkers();
      this.addDeviceLocationsToMap(this.allDevices); // Show device markers
    } else {
      this.clearMapMarkers();
      this.addClustersToMap(this.allClusters); // Show clusters
    }
  }

  private createClusterMarker(
    latitude: number,
    longitude: number,
    cluster: any
  ): google.maps.Marker {
    const marker = new google.maps.Marker({
      position: { lat: latitude, lng: longitude },
      map: this.map, // Ensure marker is added to the map
      icon: {
        url: '../../../assets/images/map-marker-green.svg',
        scaledSize: new google.maps.Size(30, 30),
      },
    });

    marker.addListener('click', () => {
      const popupContent = this.generatePopupContent(cluster);
      this.infoWindow.setContent(popupContent);
      this.infoWindow.open(this.map, marker);
    });

    return marker;
  }

  private createDeviceMarker(
    latitude: number,
    longitude: number,
    device: any
  ): google.maps.Marker {
    const marker = new google.maps.Marker({
      position: { lat: latitude, lng: longitude },
      map: this.map, // Ensure marker is added to the map
      icon: {
        url: '../../../assets/images/map-marker-red.svg',
        scaledSize: new google.maps.Size(30, 30),
      },
    });
    marker.addListener('click', () => {
      const popupContent = this.generateDevicePopupContent(device);
      this.infoWindow.setContent(popupContent);
      this.infoWindow.open(this.map, marker);
    });

    return marker;
  }

  private clearMapMarkers(): void {
    this.mapMarkers.forEach((marker) => marker.setMap(null));
    this.deviceMarkers.forEach((marker) => marker.setMap(null));
    this.markerClusterGroup?.clearMarkers();
    // this.markerDeviceGroup?.clearMarkers();

    this.mapMarkers = [];
    this.deviceMarkers = [];
  }
  // private cleaDeviceMarkers(): void {
  //   this.deviceMarkers.forEach((marker) => marker.setMap(null));
  //   this.markerDeviceGroup?.clearMarkers();
  //   this.deviceMarkers = [];
  // }

  private generatePopupContent(cluster: any): string {
    return `
    <div style="text-align: left;">
      <strong>Gateway:</strong><br>
      Device ID: ${cluster.deviceId || 'N/A'}<br>
      Last Data Read: ${cluster.lastDataRead || 'N/A'}<br>
      Meter Status: ${cluster.meterStatus || 'N/A'}<br>
    </div>
  `;
  }

  private generateDevicePopupContent(device: any): string {
    return `
    <div style="text-align: left;">
    <strong>Device:</strong><br>
    Device ID: ${device.deviceId || 'N/A'}<br>
    Last Data Read: ${device.lastDataRead || 'N/A'}<br>
    Meter status: ${device.meterStatus || 'N/A'}<br>
    </div>
  `;
  }

  // Uncomment if needed
  // private clearMapMarkers(): void {
  //     if (this.markerClusterGroup) {
  //         this.markerClusterGroup.clearLayers();
  //     }
  // }

  realTimeWidgetsUpdation() {
    this.webSocketService
      .listenForUpdates(environment.DashboardWidgetRealTimeEvent)
      .subscribe((data) => {
        this.onZoneChange();
      });
  }

  ngOnDestroy() {
    this.webSocketService.disconnect();
  }

  // private clearMapMarkers(): void {
  //   this.markers.forEach((marker) => {
  //     this.map?.removeLayer(marker);
  //   });
  //   this.markers = [];
  // }
  // private clearMapMarkers(): void {
  //   this.markerClusterGroup?.clearLayers();
  // }
  validateDate(date: any) {
    if (date) {
      return date;
    } else {
      return '--/--/----';
    }
  }

  convertAndRound(value: number): number {
    return value % 1 === 0 ? value : parseFloat(value.toFixed(2));
  }

  filter(): void {
    const startDate = this.filterForm.get('fromDate')?.value;
    const endDate = this.filterForm.get('tillDate')?.value;
    if (!startDate && !endDate) {
      this.toastr.error('Please select both from and to dates', 'Home');
      return;
    }
    if ((startDate && !endDate) || (!startDate && endDate)) {
      this.toastr.error('Please select both from and to dates', 'Home');
      return;
    } else {
      this.getWaterConsumptionWidgetDetails();
    }
  }

  clearFilter(): void {
    this.filterForm.reset();
    this.getWaterConsumptionWidgetDetails();
  }

  exportWateruses() {
    const startDate = this.filterForm.get('fromDate')?.value;
    const endDate = this.filterForm.get('tillDate')?.value;
    if (!startDate && !endDate) {
      this.toastr.error('Please select both from and to dates', 'Home');
      return;
    }
    // If one date is selected and the other is missing, show an error
    if ((startDate && !endDate) || (!startDate && endDate)) {
      this.toastr.error('Please select both from and to dates', 'Home');
      return;
    }
    this.spinner.show();

    let body = {
      params: {
        zone_id: this.selectedZone,
        fromDate: this.startDate ? this.startDate : '',
        endDate: this.endDate ? this.endDate : '',
      },
    };
    this.deviceService.exportWateruses(body).subscribe(
      (data: Blob) => {
        const blob = new Blob([data], {
          //type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          type: 'application/octet-stream',
        });
        saveAs(blob, 'Water-consumption-data.xlsx');
        this.toastr.success(
          'Water consumption data exported successfully',
          'Home'
        );
        this.spinner.hide();
      },
      (error) => {
        let errorMessage =
          typeof error.error.message === 'object'
            ? error.error.message.Text
            : error.error.message;
        this.toastr.error(errorMessage, 'Home');
        console.log('error message: ', error.error.message);
        this.spinner.hide();
      }
    );
  }

  getErrorMessage(controlName: string): string {
    const control = this.filterForm.get(controlName);
    if (control?.hasError('incomplete')) {
      return `Both start and till dates must be selected`;
    }
    return '';
  }

  validateDates() {
    const startDate = this.filterForm.get('formDate')?.value;
    const endDate = this.filterForm.get('tillDate')?.value;

    this.filterForm.get('formDate')?.setErrors(null);
    this.filterForm.get('tillDate')?.setErrors(null);

    if ((startDate && !endDate) || (!startDate && endDate)) {
      this.filterForm.get('formDate')?.setErrors({ incomplete: true });
      this.filterForm.get('tillDate')?.setErrors({ incomplete: true });
      return false;
    }

    return true;
  }
}
